export default __webpack_public_path__ + "static/media/F2-female-02_mos_JTAN.e144beb9.wav";